package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.unit.TextUnit
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.screens.randomVerse.ui.model.toAnnotatedText
import com.eladfinish.bible.contest.text.SpanType
import com.eladfinish.bible.contest.text.SpannableStringKMP
import com.eladfinish.bible.contest.text.SpannedRange
import kotlinx.collections.immutable.toImmutableList

@Composable
internal fun rememberChapterAnnotatedText(
    chapterData: ChapterData,
    controller: GoToMarkerController,
    baseFontSize: TextUnit,
): AnnotatedString {
    val highlightRange = controller.transientHighlightRange
    val alpha = rememberHighlightAlpha(highlightRange)

    val transientSpan: SpannedRange? = remember(highlightRange, alpha) {
        val r = highlightRange ?: return@remember null
        if (alpha <= 0.01f) return@remember null

        SpannedRange(
            spanType = SpanType.BackgroundColor(Color.Yellow.copy(alpha = alpha)),
            textRange = TextRange(start = r.start, end = r.end),
        )
    }

    return remember(chapterData.content, chapterData.spannedRangeList, transientSpan, baseFontSize) {
        val merged = if (transientSpan != null) {
            chapterData.spannedRangeList + transientSpan
        } else {
            chapterData.spannedRangeList
        }

        SpannableStringKMP(
            charSequence = chapterData.content,
            spannedRangeList = merged.toImmutableList(),
        ).toAnnotatedText(baseFontSize = baseFontSize).annotatedString
    }
}
